export default __webpack_public_path__ + "static/media/animation.3069bb15.gif";